import axios from "axios";
import { useQuery } from "react-query";
import { imageUrl, API_URL } from "../../../api/config";

const fetchNew = async (slug: string) => {
    const { data } = await axios.get(`${API_URL}/api/v1/news/${slug}`);
    return data.body;
};

export const useNew = ({slug}: {slug: string}) => {
    const { data, isLoading } = useQuery(["news", slug], () => fetchNew(slug), {
        onError: (error) => {
            console.log("error", error);
        }
    });

    let resultArray: string[][] = [];

    if(data?.description){
        let paragraphs = data.description.split(/<\/?p>/).filter(Boolean);
        resultArray = paragraphs.map((paragraph: any) => {
            let cleanedString = paragraph.replace(/&[^;\s]+;/g, '');
            let lines = cleanedString.split(/<br\s*\/?>/).map((s: any) => s.trim()).filter(Boolean);
            return lines;
        });
    }

    const linkRegex = /^<a.*<\/a>$/;

    const extractLink = (str: any) => {
        const match = str.match(/href="([^"]+)"/);
        return match ? match[1] : null;
    };

    const texts: any = [];
    const links: any = [];

    resultArray.flat().forEach((item: any) => {
        if (linkRegex.test(item)) {
            const link = extractLink(item);
            if (link) {
                links.push(link);
            }
        } else {
            texts.push(item);
        }
    });

    return {
        news: {
            ...data,
            image: imageUrl(data?.image),
            otherImagesNews: data?.otherImagesNews?.map((img: any) => ({ image: imageUrl(img.image) })),
            description: texts,
            video: links
        },
        isLoading,
    };
};
